import { DownloadKitButtonSelectorWebComponent } from './component/DownloadKitButtonSelectorWebComponent';
import { WEB_COMPONENT_DOWNLOAD_KIT_BUTTON } from '../../webcomponents.constants';

export { DownloadKitButtonSelectorWebComponent };

window.customElements.define(WEB_COMPONENT_DOWNLOAD_KIT_BUTTON, DownloadKitButtonSelectorWebComponent);
